export default __webpack_public_path__ + "static/media/Group 10387.31cef287.svg";